import { render, staticRenderFns } from "./AlarmContent.vue?vue&type=template&id=5872afcd&scoped=true&"
import script from "./AlarmContent.vue?vue&type=script&lang=js&"
export * from "./AlarmContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5872afcd",
  null
  
)

export default component.exports